import { mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";

export const MainLayout = styled.main<{ footerHeight: number }>`
  min-height: calc(100vh - (${GLOBAL_NAVI_HEIGHT.PC}px + ${({ footerHeight }) => footerHeight}px));
  min-height: calc(var(--1svh, 1vh) * 100 - (${GLOBAL_NAVI_HEIGHT.PC}px + ${({ footerHeight }) => footerHeight}px));
  min-height: calc(100svh - (${GLOBAL_NAVI_HEIGHT.PC}px + ${({ footerHeight }) => footerHeight}px));
  ${mq.sp} {
    min-height: calc(100vh - (${GLOBAL_NAVI_HEIGHT.SP}px + ${({ footerHeight }) => footerHeight}px));
    min-height: calc(var(--1svh, 1vh) * 100 - (${GLOBAL_NAVI_HEIGHT.SP}px + ${({ footerHeight }) => footerHeight}px));
    min-height: calc(100svh - (${GLOBAL_NAVI_HEIGHT.SP}px + ${({ footerHeight }) => footerHeight}px));
  }
  //memo 一番下までページスクロールするとオレンジ色になってしまうのでこちらが必要
  :focus-visible {
    outline: none;
  }
`;
